export function matchPath(itemPath: string, currentPath: string): boolean {
  if (!itemPath || !itemPath.startsWith("/")) return false
  if (itemPath === "/") return currentPath === "/"
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`)
}
